<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">INFORME DERECHO A CURIA</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>INFORME GENERAL DERECHO A CURIA 90%</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-8">
          <span><strong>VICARIA: </strong></span>
          <Dropdown
            v-model="vicariaSelected"
            :options="vicarias"
            optionLabel="nombre"
            optionValue="id"
            :filter="true"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>GESTIÓN: </strong></span>
          <Dropdown
            v-model="gestion"
            :options="gestiones"
            :filter="false"
            placeholder="Seleccionar"
          />
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Buscar'"
            :loading="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>
    <div v-if="enviando" class="text-center p-5">
      <ProgressSpinner style="width: 50px; height: 50px" />
      <p class="mt-3 text-lg text-gray-600">Cargando reporte...</p>
    </div>

    <div v-else>
      <div
        class="flex justify-content-end"
        style="padding: 5px"
        v-if="curias.length > 0"
      >
        <Button
          label="Generar PDF"
          icon="pi pi-file-pdf"
          class="p-button-danger"
          v-tooltip.top="'Generar PDF'"
          :loading="generandoPDF"
          @click="generarPDF"
        />
      </div>
      <div v-for="item in curias" :key="item.nombre_vicaria">
        <div class="overflow-x-auto">
          <table class="min-w-full border text-sm">
            <thead>
              <tr>
                <th
                  :colspan="columnas_meses.length + 3"
                  class="text-left p-2"
                  style="font-size: 1.3rem; font-weight: bold; color: #005f91"
                >
                  {{ item.nombre_vicaria }}
                </th>
              </tr>
              <tr style="background-color: #002236; color: white">
                <th class="border p-2 text-left">PARROQUIA</th>
                <th
                  v-for="mes in columnas_meses"
                  :key="mes"
                  class="border p-2 text-center"
                >
                  {{ mes }}
                </th>
                <th class="border p-2 text-center">TOTALES</th>
                <th class="border p-2 text-center">OBSERVACIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="parroquia in item.parroquias"
                :key="parroquia.nombre_parroquia"
                class="hover:bg-gray-50"
              >
                <td class="border p-1 border-blue-600 font-semibold">
                  {{ parroquia.nombre_parroquia }}
                </td>
                <td
                  v-for="mes in columnas_meses"
                  :key="mes"
                  class="border p-1 text-right"
                  :class="{
                    'bg-blue-100 text-blue-900 font-semibold':
                      parroquia.meses[mes] > 0,
                  }"
                >
                  {{ convertirNumeroGermanicFormat(parroquia.meses[mes] || 0) }}
                </td>
                <td
                  class="border p-1 text-right font-semibold bg-blue-200 text-blue-900"
                >
                  {{ convertirNumeroGermanicFormat(parroquia.total_parroquia) }}
                </td>
                <td class="border p-1 text-sm">
                  {{ parroquia.observaciones }}
                </td>
              </tr>
              <tr
                style="background-color: #e0e7ef; border-top: 2px solid #334155"
                class="font-bold"
              >
                <td
                  class="border p-1 text-right"
                  :colspan="columnas_meses.length + 1"
                >
                  TOTAL {{ item.nombre_vicaria }}
                </td>
                <td
                  class="border p-1 text-right bg-blue-300 text-blue-900 font-bold"
                >
                  {{ convertirNumeroGermanicFormat(item.total_vicaria) }}
                </td>
                <td class="border p-1"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        v-if="curias.length === 0 && !enviando"
        class="text-center p-8 bg-gray-50 rounded-lg"
      >
        <i class="pi pi-info-circle text-4xl text-info-400 mb-3"></i>
        <p class="text-lg text-red-600">
          No se encontraron datos para la búsqueda realizada. Por favor, ajuste
          los filtros y vuelva a intentarlo.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import VicariaService from "@/service/VicariaService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      enviando: false,
      curias: [],
      generandoPDF: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      vicariaSelected: 0,
      vicarias: [],
      columnas_meses: [],
      gestion: new Date().getFullYear(),
      gestiones: [],
    };
  },
  vicariaService: null,
  auth: null,
  created() {
    this.vicariaService = new VicariaService();
    this.auth = useAuth();
  },
  mounted() {
    this.getVicarias();
    this.generarGestiones();
  },
  methods: {
    generarGestiones() {
      const añoActual = new Date().getFullYear();
      const rango = 6; // desde año actual hasta 5 años después
      this.gestiones = Array.from({ length: rango }, (_, i) => añoActual + i);
    },
    getVicarias() {
      this.vicariaService
        .getVicariasAll()
        .then((data) => {
          this.vicarias = data.vicarias;
          this.vicarias.unshift({ id: 0, nombre: "TODAS" });
        })
        .catch((error) => console.log(error));
    },
    generarPDF() {
      if (this.curias.length > 0) {
        this.generandoPDF = true;
        let datos = {
          vicaria_id: this.vicariaSelected,
          gestion: this.gestion,
          sucursales: this.auth.user?.sucursales ?? []
        };
        this.vicariaService.imprimirPDF(datos).then(() => {
          this.generandoPDF = false;
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: "Se genero el PDF correctamente",
            life: 3000,
          });
        });
      } else
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para generar el reporte",
          life: 3000,
        });
    },
    BuscarFiltro() {
      this.curias = [];
      this.enviando = true;
      this.cargarReporteCurias();
    },
    cargarReporteCurias() {
      let datos = {
        vicaria_id: this.vicariaSelected,
        gestion: this.gestion,
        sucursales: this.auth.user?.sucursales ?? [],
      };
      this.vicariaService
        .filtrarCurias(datos)
        .then((data) => {
          this.curias = data.curias;
          this.columnas_meses = data.columnas_meses;
          this.enviando = false;
        })
        .catch((error) => {
          this.enviando = false;
          console.log(error);
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}
.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 3px;
}

.table-header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.text-primary {
  color: #005f91;
}

.bg-primary {
  background-color: #005f91;
}

.hover-effect:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.bg-blue-100 {
  background-color: #dbeafe; /* azul claro */
}

.bg-blue-200 {
  background-color: #bfdbfe; /* azul más marcado */
}

.bg-blue-300 {
  background-color: #93c5fd; /* azul fuerte */
}

.text-blue-900 {
  color: #1e3a8a; /* azul oscuro */
}

table.min-w-full {
  border-collapse: separate;
  border-spacing: 0 1px;
  //pongo borde a la tabla
  border: 1px solid #e5e7eb;
}
//ahora a la celda igual borde abajo
th,
td {
  border-bottom: 1px solid #e5e7eb;
}
</style>
